export enum GetUserOfCoordinationResultType {
    UnauthorizedUser = 'You are unauthorized for this DataMiner System.',
    UnauthorizedUserClaim = `You are not allowed to view this DataMiner System users because you don't have the required claim.`,
    OrganizationNotFound = 'The organization was no longer found.',
    DMSNotFound = 'The DataMiner System was no longer found.',
    Timeout = 'The request took too long',
    Unknown = 'An unknown error has occurred.',
}
